import { all, takeEvery, put, call } from 'redux-saga/effects'
import axiosMethod from '../../utilities/apiCaller'

import actions from './actions'

const { txnPrivateGet } = axiosMethod

const getBeneficiariesByClientId = (clientId, token) => {
  return txnPrivateGet(
    `tx-service/beneficiaries?clientId=${clientId}&beneStatus=active&limit=0`,
    token,
  ).then(response => {
    return response.data.data
  })
}

export function* getBeneficiries(values) {
  const { payload } = values
  const { clientId, token } = payload
  try {
    const response = yield call(getBeneficiariesByClientId, clientId, token)
    yield put({
      type: actions.GET_BENEFICIARIES_BY_CLIENT_ID_SUCCESS,
      value: response.beneficiaries,
    })
  } catch (e) {
    yield put({
      type: actions.GET_BENEFICIARIES_BY_CLIENT_ID_FAILURE,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_BENEFICIARIES_BY_CLIENT_ID, getBeneficiries)])
}
